import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface SummaryLineProps {
  label: string | undefined;
  value: string | number | null | undefined | JSX.Element;
}

export const SummaryLine = ({ label, value }: SummaryLineProps) => {
  if (!label || !value) {
    return null;
  }

  return (
    <Font className="overflow-text-ellipsis" variant="body2" style={{ maxWidth: '100%' }}>
      <Text tId={label} />
      {': '}
      {value}
    </Font>
  );
};
